@use '@lib/assets/styles/main.scss' as *;
@use "@lib/components/Link/LinkExtends" as *;

$imageSize: 88px;
$compactImageSize: 76px;

.img {
  margin-bottom: 16px;
  img, svg {
    display: block;
  }
}

.body {
  display: flex;
  gap: 16px;
}

// Compact mode styles
.compactContainer {
  display: flex;
  align-items: center;
  gap: 24px;
}

.compactImageWrapper {
  flex-shrink: 0;
  width: $compactImageSize;
  height: $compactImageSize;
  border-radius: 4px;
  border: 1px solid $gray200;
  overflow: hidden;
}

.compactImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.compactPlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $gray100;
  color: $gray0;
}

.label {
  margin-bottom: 8px;
}
